import React from 'react';
import RoleBasedRoute from './RoleBasedRoute';

/**
 * Protected route specifically for advertiser users
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @returns {React.ReactNode} - The protected component or redirect
 */
const AdvertiserRoute = ({ children }) => {
  return (
    <RoleBasedRoute 
      allowedRoles="Advertiser" 
      redirectPath="/login"
    >
      {children}
    </RoleBasedRoute>
  );
};

export default AdvertiserRoute;
